import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import SupportEmailConfirmation from '@/plugins/graphql/mutations/app-support-email-recipient-confirmation.gql';
import SupportEmailResend from '@/plugins/graphql/mutations/app-support-email-recipient-resend.gql';
let Confirmation = class Confirmation extends Mixins(AlertMixin) {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.confirmed = false;
        this.resending = false;
    }
    setValidConfirmation() {
        this.loading = false;
        this.confirmed = true;
    }
    setInvalidConfirmation() {
        this.loading = false;
        this.confirmed = false;
    }
    resendConfirmation() {
        this.resending = true;
        this.$apollo
            .mutate({
            mutation: SupportEmailResend,
            variables: {
                input: {
                    confirmationToken: this.confirmationToken,
                },
            },
        })
            .then(() => {
            this.resending = false;
            this.successNotification('Resend Email Success');
        })
            .catch(() => {
            this.resending = false;
            this.errorNotification('Resend Email Failed');
        });
    }
    mounted() {
        this.$apollo
            .mutate({
            mutation: SupportEmailConfirmation,
            variables: {
                input: {
                    confirmationToken: this.confirmationToken,
                },
            },
        })
            .then((result) => {
            if (!result.data.appSupportEmailRecipientConfirmation.confirmed) {
                this.setInvalidConfirmation();
            }
            else {
                this.setValidConfirmation();
            }
        })
            .catch(() => {
            this.setInvalidConfirmation();
        });
    }
};
__decorate([
    Prop({ type: String, required: true })
], Confirmation.prototype, "confirmationToken", void 0);
Confirmation = __decorate([
    Component({
        components: {
            ActionButton,
        },
        computed: {
            confirmationTitle() {
                if (this.loading) {
                    return '';
                }
                if (this.confirmed) {
                    return 'Verification Success.';
                }
                return 'Email verification link is expired.';
            },
            confirmationSubTitle() {
                if (this.loading) {
                    return 'Please wait...';
                }
                if (this.confirmed) {
                    return 'You have successfully verified your email address.';
                }
                return '';
            },
            confirmationImageSrc() {
                if (this.loading) {
                    return require('@/assets/images/confirmation-loading.png');
                }
                if (this.confirmed) {
                    return require('@/assets/images/confirmation-success.png');
                }
                return require('@/assets/images/confirmation-invalid.png');
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = false;
                return true;
            });
        },
    })
], Confirmation);
export default Confirmation;
